import { useDispatch, useSelector } from 'react-redux'
import { appActions } from '@/store/slices/appSlice'
import { AppDispatch, RootState } from '@/store/store'
import { useCallback } from 'react'

export const useUtcSwitcher = () => {
  const { isUtc } = useSelector((state: RootState) => state.app)
  const dispatch = useDispatch<AppDispatch>()

  const toggleUtc = useCallback(() => {
    dispatch(appActions.setUtc(!isUtc))
  }, [dispatch, isUtc])

  // Function to format date based on UTC or Local preference
  const formatDate = useCallback(
    (date: string | Date) => {
      const dateObj = typeof date === 'string' ? new Date(date.toUpperCase().includes('Z') ? date : `${date}Z`) : date

      // Use 'UTC' timeZone for UTC formatting, and default for local formatting
      return dateObj.toLocaleString(undefined, { timeZone: isUtc ? 'UTC' : undefined })
    },
    [isUtc],
  )

  return { isUtc, toggleUtc, formatDate }
}
